export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Favourites.vue?vue&type=template&id=fbed8cc4&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Favourites.vue?vue&type=template&id=fbed8cc4&
// module id = 166
// module chunks = 6